import type { ComponentChildren, JSX } from 'preact';
import { useState } from 'preact/hooks';

/**
 * Staggered-entrance, hover-lift card shell shared by the grid sections
 * (WhyCarii, HowItWorks, TeamSection). Detaches its entrance animation once
 * finished — same reason as ServiceTile's kereta-tile: `both` fill-mode
 * otherwise keeps asserting `transform: none` forever, permanently blocking
 * `.lift-card`'s hover transform.
 */
export function RiseCard({
  index,
  style,
  children,
}: {
  index: number;
  style?: JSX.CSSProperties;
  children: ComponentChildren;
}) {
  const riseDelay = `${(index * 0.06).toFixed(2)}s`;
  const [hasEntered, setHasEntered] = useState(false);
  const entranceAnimation = hasEntered
    ? undefined
    : `cRise .6s ${riseDelay} cubic-bezier(.22,1,.36,1) both`;

  return (
    <div
      class="lift-card"
      onAnimationEnd={() => setHasEntered(true)}
      style={{
        borderRadius: '22px',
        padding: '24px',
        backdropFilter: 'blur(var(--blur))',
        WebkitBackdropFilter: 'blur(var(--blur))',
        animation: entranceAnimation,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
